import axios from "axios";
import apiConfig from "../config/apiConfig";

const adsApiInstance = axios.create({
  baseURL: apiConfig.endpoints.adsService.baseURL,
  timeout: 15000,
});

const trackClick = async (payload) => {
  try {
    const response = await adsApiInstance.post(
      apiConfig.endpoints.adsService.routes.trackClick,
      payload
    );
    return response.data ?? response;
  } catch (error) {
    return error.response?.data ?? error;
  }
};

const getCatalog = async () => {
  try {
    const response = await adsApiInstance.get(
      apiConfig.endpoints.adsService.routes.getCatalog
    );
    return response.data ?? response;
  } catch (error) {
    return error.response?.data ?? error;
  }
};

const getSummary = async (days = 30) => {
  try {
    const response = await adsApiInstance.get(
      apiConfig.endpoints.adsService.routes.getSummary,
      { params: { days } }
    );
    return response.data ?? response;
  } catch (error) {
    return error.response?.data ?? error;
  }
};

const getTopIps = async ({ adId, limit = 20 } = {}) => {
  try {
    const response = await adsApiInstance.get(
      apiConfig.endpoints.adsService.routes.getTopIps,
      { params: { adId, limit } }
    );
    return response.data ?? response;
  } catch (error) {
    return error.response?.data ?? error;
  }
};

const adsApi = {
  trackClick,
  getCatalog,
  getSummary,
  getTopIps,
};

export default adsApi;
